import NewSwitch from "pages/business/Subscription/NewSwitch";
import SettingsBasicSelect from "../../../components/Shared/SettingsBasicSelect";
import BasicTextInput from "../../../components/BasicInputs/BasicTextInput";

function PrintFactorSetting(props: any) {
  const { settingData, setSettingData } = props;

  const onChange = (key: any, value: any) => {
    let temp = {
      ...settingData,
      [key]: value,
    };
    setSettingData(temp);
  };

  // const selectedItem = (options: any, key: any, defaultLabel: string) => {
  //   const keyValue = settingData[key];
  //   const placeHolder = options.find((i: { value: any }) => i.value == keyValue);

  //   return placeHolder?.label || defaultLabel;
  // };

  return (
    <div className="flex container flex-col ">
      <div className="flex flex-col w-full mb-10">
        <span className="text-[#7E8C9E]">فیش پرینت</span>
      </div>
      {defaultData.map((item, index) => (
        <div key={index} className="flex  flex-row items-start w-full py-4 mb-6">
          <div className="flex flex-1 flex-row item-center">
            <NewSwitch
              active={settingData[item.key] || undefined}
              activeColor="#30D74B"
              size={2}
              onChange={(value) => {
                onChange(item.key, value);
              }}
            />
            <span className="text-base mr-4 color-[#424242]">{item.label}</span>
          </div>
          <div className="flex w-1/3  justify-end">
            {item.hasInput && (
              <BasicTextInput
                fullWidth
                disabled={!settingData[item.key] || undefined}
                textArea={item.hasInput.type === "textArea"}
                label={item.hasInput.label}
                onChange={(e) => {
                  onChange(item.hasInput.key, e);
                }}
                // placeHolder={settingData[item.hasInput.key] ?? ""}
                val={settingData[item.hasInput.key]}
              />
            )}
          </div>
        </div>
      ))}

      <div className="flex flex-col w-full mb-10">
        <span className="text-[#7E8C9E]">لیبل</span>
      </div>
      {labelData.map((item, index) => (
        <div key={index} className="flex justify-between w-full py-4 mb-6">
          <div className="flex gap-2">
            <NewSwitch
              active={settingData[item.key] || undefined}
              activeColor="#30D74B"
              size={2}
              onChange={(value) => onChange(item.key, value)}
            />
            <span className="text-base mr-4 color-[#424242]">{item.label}</span>
          </div>
          <div className="w-72">
            {item.hasInput && (
              <BasicTextInput
                fullWidth
                disabled={!settingData[item.key] || undefined}
                textArea={item.hasInput.type === "textArea"}
                label={item.hasInput.label}
                onChange={(e) => {
                  onChange(item.hasInput.key, e);
                }}
                val={settingData[item.hasInput.key]}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default PrintFactorSetting;

const defaultData = [
  {
    label: "نمایش لوگو",
    description: "",
    key: "fishPrintDisplayLogo",
    hasInput: null,
  },
  {
    label: "نمایش تلفن",
    description: "",
    key: "fishPrintDisplayPhone",
    hasInput: null,
  },
  {
    label: "نمایش وبسایت",
    description: "",
    key: "fishPrintDisplayWebsite",
    hasInput: null,
  },
  {
    label: "نمایش آدرس",
    description: "",
    key: "fishPrintDisplayAddress",
    hasInput: null,
  },
  {
    label: "نمایش خریدار",
    description: "",
    key: "fishPrintDisplayCustomer",
    hasInput: null,
  },
  {
    label: "نمایش بارکد",
    description: "",
    key: "fishPrintDisplayBarcode",
    hasInput: null,
  },
  {
    label: "نمایش شعبه",
    description: "",
    key: "fishPrintDisplayBranch",
    hasInput: null,
  },
  {
    label: "چاپ نسخه دوم",
    description: "",
    key: "printSecondVersion",
    hasInput: null,
  },
  {
    label: "نمایش موبایل",
    description: "",
    key: "fishPrintDisplayMobile",
    hasInput: null,
  },
  {
    label: "نمایش پروژه",
    description: "",
    key: "fishPrintDisplayProject",
    hasInput: null,
  },
  {
    label: "نمایش تراز خریدار",
    description: "",
    key: "fishPrintDisplayBuyerBalance",
    hasInput: null,
  },
  {
    label: "نمایش توضیحات",
    description: "",
    key: "fishPrintDisplayDescription",
    hasInput: {
      label: "توضیحات",
      key: "fishPrintDescription",
      type: "textArea",
    },
  },
];

const labelData = [
  {
    label: "نمایش نام کسب و کار",
    description: "",
    key: "labelPrintDisplayBusinessName",
    hasInput: null,
  },
  {
    label: "نمایش نام کالا",
    description: "",
    key: "labelPrintDisplayProductName",
    hasInput: null,
  },
  {
    label: "نمایش آدرس کالا",
    description: "",
    key: "labelPrintDisplayAddress",
    hasInput: null,
  },
  {
    label: "نمایش بارکد متنی",
    description: "",
    key: "labelPrintDisplayBarcodeText",
    hasInput: null,
  },
  {
    label: "نمایش قیمت",
    description: "",
    key: "labelPrintDisplayPrice",
    hasInput: null,
  },
  {
    label: "نمایش توضیحات",
    description: "",
    key: "labelPrintDisplayDescription",
    hasInput: {
      label: "توضیحات",
      key: "labelPrintDescription",
      type: "textArea",
    },
  },
];
